import React from 'react'
import passportPhotoExample from '@helpers/passport-photo-example'
import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import { BGCSES, BJCS } from '@constants/national-exams'
import moment from 'moment'
import { fullName } from '@modules/form-wizard/utils'
import Swal from 'sweetalert2'
import toastr from '@modules/toastr'

export default class NationalYouthGuard extends React.Component {
  resource = '/national_security/national_youth_guards'
  form_key = 'national_youth_guard'
  defaults = {}

  // Delete lines as needed
//   fee           = 99
  free          = true
  postpaid      = false
  skip_location = true
  hide_buttons  = {
    status: true,
    deny: true,
  }
  custom_actions = [
    {
      text: 'Set Interview Details',
      icon: 'check',
      roles: [['officer', 'senior_officer']],
      test: r => {
        if (['interview approved'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: async record => {
        // Set value of Inspection Date
        const datePrompt = await Swal.fire({
          icon: 'question',
          title: 'Interview Details?',
          html: `
            <p>
              What is your recommended interview date/venue regarding the applicant,
              <strong>${fullName(record.user, 'initial')}</strong>,
              <br/>
              <span><b>Island of Residence:</b> <u>${record.island_of_residence || 'N/A'}</u></span>,
              <br/>
              <span><b>Is a student:</b> <u>${record.student ? 'Yes' : 'No'}</u></span>
              <br/>
              <span><b>Employed:</b> <u>${record.employed ? 'Yes' : 'No'}</u></span>
            </p>

            <div class="mt-3">
              <div class="d-flex flex-row justify-content-center" style="gap: 1rem; margin-bottom: 1rem; font-size: 1rem;">
                <div>
                  <h5 class="font-bold">Date</h5>
                  <input type="date" id="interview-date" class="form-control" min="${moment().format('YYYY-MM-DD')}" placeholder="Interview Date">
                </div>
                <div>
                  <h5 class="font-bold">Time</h5>
                  <input type="time" id="interview-time" class="form-control" name="interview-time" placeholder="Interview Time">
                </div>
              </div>

              <p class="d-flex flex-column">
                <h5 class="font-bold">Venue</h5>
                <input type="text" id="interview-venue" class="form-control" placeholder="Interview Venue" style="">
                <span class="text-muted"><i>You can enter the zoom link details here if the interview is virtual</i></span>
              </p>
            </div>
          `,

          showCancelButton: true,
          confirmButtonText: 'Submit',
          preConfirm: () => {
            const date = (document.getElementById('interview-date')).value;
            const time = (document.getElementById('interview-time')).value;
            const venue = (document.getElementById('interview-venue')).value;
            if (!date) {
              Swal.showValidationMessage('Please select a date');
            }
            if (!time) {
              Swal.showValidationMessage('Please select a time');
            }
            if (!venue) {
              Swal.showValidationMessage('Please enter a venue');
            }
            return { date, time, venue };
          },
        })

        if (datePrompt.isDismissed) return

        if (datePrompt.isConfirmed) {
          const { date, time, venue } = datePrompt.value
          const interviewDatetime = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm')

          // console.log('Submitting interview details:', {
          //   interview_datetime: interviewDatetime.toISOString(),
          //   interview_venue: venue,
          //   datePrompt: datePrompt.value,
          // })

          await this.submitToNewLevel('approved', record, {
            interview_datetime: interviewDatetime.toISOString(),
            interview_venue: venue,
          })
        }
      }
    },
    {
      text: 'Approve for Interview',
      icon: 'check',
      roles: [['officer', 'senior_officer']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'success',
          title: 'Confirm Approval for Interview',
          text: 'Are you sure you want to approve this application for an interview?',
          confirmButtonText: 'Approve',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            await this.submitToNewLevel('interview approved', record, null)
          }
        }),
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: [['officer', 'senior_officer']],
      test: r => {
        if (['pending', 'processing', 'interview approved'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            await this.submitToNewLevel('denied', record, null)
          }
        }),
    },
  ]

  defaults = {
    bank_name: 'Bank of The Bahamas',
  }

  submitToNewLevel = async (value, record, interviewOpts = {}) => {
    this.setState({ loading: true })
    const { resource, form_key } = this
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
          ...(interviewOpts),
        },
      })

      toastr.success('Success', 'The application was successfully updated')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Something went wrong with trying to update this application')
    } finally {
      this.setState({ loading: false })
    }
  }

  validate = form => {
    let shirt_size = form.shirt_size
    if(shirt_size == 'other') shirt_size = form.other_shirt_size;

    let pants_size = form.pants_size
    if(pants_size == 'other') pants_size = form.other_pants_size;

    const update = {
      shirt_size: shirt_size,
      pants_size: pants_size,
    }

    return update
  }

  foremost = null

  columns = props => [
    {
      name: 'Island/Residence',
      selector: row => row.island_of_residence?.capitalize() || 'N/A',
      sortable: true,
      searchable: r => r.island_of_residence,
    },
    {
      name: 'Nationality',
      selector: row => row.nationality?.capitalize() || 'N/A',
      sortable: true,
      searchable: r => r.nationality,
    },
    {
      name: 'Interview Date/Time',
      selector: row => row.interview_datetime ? moment(row.interview_datetime).format('MMMM Do YYYY, h:mm a') : 'N/A',
      sortable: true,
      searchable: r => r.interview_datetime,
    }
  ]

  fields = form => [
    // {
    //     heading: '*Note: This application will service both Parliament (16-25) & Senate (26-35) applicants.*',
    //     view: false,
    // },
    {
      name: 'interview_datetime',
      label: 'Interview Date/Time',
      type: 'datetime',
      required: false,
      hide: true,
      view: {
        value: v => v ? moment(v).format('MMMM Do YYYY, h:mm a') : 'N/A',
      }
    },
    {
      name: 'interview_venue',
      label: 'Interview Venue',
      required: false,
      hide: true,
      view: {
        value: v => v || 'N/A',
      }
    },

    "::Applicant Details",

    {
        name: 'nationality',
        label: 'Nationality',
    },
    {
        name: 'island_of_residence',
        label: 'Island of Residence',
        options: islands,
    },
    {
        name: 'street_address',
        label: 'Street Address',
        // hide: form.i_am_youth,
    },
    {
        name: 'home_phone_contact',
        label: 'Home Phone #',
        type: 'phone',
        required: false,
    },
    {
        name: 'mobile_phone_contact',
        label: 'Mobile Phone #',
        type: 'phone',
        required: true,
    },
    {
        name: 'marital_status',
        label: 'Marital Status',
        options: ['Single', 'Married', 'Divorced', 'Widowed'],
    },
    {
        name: 'number_of_children',
        label: 'How many children/dependents do you have?',
        type: 'integer',
        hint: 'Type 0 if not applicable',
    },
    {
        name: 'convicted_of_crime',
        label: 'Have you ever been convicted of a crime or have any pending court cases? ',
        type: 'select:bool',
    },
    {
        name: 'explain_interest',
        label: 'In two sentences or less, explain why you are interested in joining the National Youth Guard?',
        type: 'textarea',
        maxLength: 500,
    },
    {
        name: 'explain_goals',
        label: `In two sentences or less, explain how does being a part of The National Youth Guard contribute to 
            the achievement of your personal and/or career goals?`,
        type: 'textarea',
        maxLength: 500,
    },
    {
        name: 'qualifications_list',
        label: `Briefly list any professional skills, hobbies, qualifications, or special interest relevant to The 
            National Youth Guard? `,
        columns: ['qualification'],
        format: v => v.qualification,
    },
    {
        name: 'memberships_list',
        label: `Briefly list any memberships, affiliations, professional societies, clubs or community organizations 
            to which you belong.`,
        columns: ['membership'],
        format: v => v.membership,
    },
    // {
    //     name: 'vaccination_status',
    //     label: 'COVID-19 Vaccination Status',
    //     options: ['Fully vaccinated', 'Partially vaccinated (one shot)', 'Not vaccinated']
    // },
    {
        name: 'shirt_size',
        options:[
            'small',
            'medium',
            'large',
            'XL',
            'XXL',
            'XXXL',
            'other'
        ]
    },
    {
        name: 'other_shirt_size',
        label: 'Please state your shirt size',
        hide: form.shirt_size !='other'
    },
    {
        name: 'pants_size',
        options:[
            '24',
            '26',
            '28',
            '30',
            '32',
            '34',
            '36',
            '38',
            '40',
            '42',
            '44',
            '46',
            '48',
            '50',
            'other'
        ]
    },
    {
        name: 'other_pants_size',
        label: 'Please state your pants size',
        hide: form.pants_size !='other'
    },

    "::Academic information",
    {
        name: 'student',
        label: 'Currently a student?',
        type: 'select:bool'
    },
    {
        name: 'name_of_school',
        label: 'What is the name of the college/school being attended?',
        hide: !form.student
    },
    {
        name: 'graduate_status',
        label: 'Are you a graduate?',
        type: 'select:bool'
    },
    {
        name: 'graduate_degree',
        label: 'State your degree',
        hide: !form.graduate_status
    },
    {
        name: 'bjcs_passed_list',
        label: `Select all BJC's passed`,
        options: BJCS,
        multi: true,
        required: false,
    },
    {
        name: 'bgcses_passed_list',
        label: `Select all BGCSE's passed`,
        options: BGCSES,
        multi: true,
        required: false,
    },
    {
        name: 'academic_certificates_list',
        label: 'List any other academic certifcates achievied',
        columns: ['academic_certificate'],
        format: v => v.academic_certificate,
        required: false,
    },

    "::Employment Information",
    {
        name: 'employed',
        label: 'Are you currently employed?',
        type: 'select:bool'
    },
    {
        name: 'employer',
        label: 'What is your place of Employment?',
        hide: !form.employed,
    },

    "::Medical Information",
    {
        name: 'food_allergies',
        label: 'Do you have any allergies?',
        type: 'select:bool'
    },
    {
        name: 'food_allergies_details',
        label: 'Please list them',
        type: 'textarea',
        hide: !form.food_allergies
    },
    {
        name: 'medical_conditions',
        label: 'Do you have any medical conditions?',
        type: 'select:bool'
    },
    {
        name: 'medical_conditions_details',
        label: 'Please list them',
        type: 'textarea',
        hide: !form.medical_conditions
    },
    {
        name: 'medication',
        label: 'Are you taking any medication/s?',
        type: 'select:bool',
    },
    {
        name: 'medication_details',
        label: 'Name(s) of medication(s)',
        type: 'textarea',
        hide: !form.medication
        // hint: 'Type N/A if not applicable'
    },
    {
        name: 'have_nhi',
        label: 'Are you enrolled with National Health Insurance (NHI)?',
        type: 'select:bool',
    },

    "::Emergency Contact",
    {
        name: 'emergency_contact_list',
        rowLabel: 'Emergency Contact',
        fields: [
          {
            name: 'first_name',
            // label: 'First name of parent/guardian'
          },
          {
            name: 'last_name',
            // label: 'Last name of parent/guardian'
          },
          {
            name: 'relationship_to_youth',
            label: 'Relation to youth',
            options: ['parent', 'guardian', 'relative'],
          },
          {
            name: 'phone_contact',
            label: 'Phone #',
            // label: 'Parent/Guardian phone contact',
            type: 'phone'
          },
          {
            name: 'alt_phone_contact',
            label: 'Alternate Phone #',
            type: 'phone',
            required: false,
          }
        ]
    },

    "::Banking Information",
    {
        name: 'have_bob_account',
        label: 'Do you have an account with the Bank of The Bahamas?',
        type: 'select:bool',
    },
    // {
    //     name: 'bank_name',
    //     label: 'Name of Bank',
    //     disabled: true,
    //     hide: !form.have_bob_account,
    //     view: {
    //         value: v => v || 'Bank of The Bahamas',
    //     }
    // },
    {
        name: 'bank_account_number',
        label: 'Bank Account Number',
        type: 'integer',
        hide: !form.have_bob_account,
    },
    {
        name: 'bank_transit_number',
        label: 'Branch (Transit #)',
        type: 'integer',
        hide: !form.have_bob_account,
    },

    "::Uploads",
    {
        name: 'police_record_upload',
        label: 'Police Record',
        key: 'image.0',
        type: 'file:image',
        required: false,
        hint: "A valid Police Record must be presented at the time of your interview.",
    },
    {
        name: 'bob_proof_upload',
        label: 'Bank of the Bahamas Proof',
        key: 'image.1',
        type: 'file:image',
        hint: `Do not upload atm card\n
            Upload either a bank statement or a bank card (the card with the account details on it)`,
        required: form.have_bob_account,
        hide: !form.have_bob_account,
    },
    {
        name: 'nhi_upload',
        label: 'Proof of NHI',
        type: 'file:all',
        key: 'image.2',
        hint: "Proof of NHI must be presented at the time of your interview.",
        hide: !form.have_nhi,
    },
    {
        name: 'nib_card_upload',
        label: 'NIB Card Upload',
        type: 'file:all',
        key: 'image.3',
    },
    {
        name: 'passport_upload',
        label: 'Passport Upload',
        type: 'file:all',
        key: 'image.4',
        hint: passportPhotoExample
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
